import { GetCartSimpleResponse, GetPurchaseListSimpleResponse } from './shopping-cart.model';

export async function getCount<R>(url): Promise<R> {
    const response = await fetch(url, {
        cache: 'no-cache',
        method: 'GET',
        credentials: 'include'
    });

    const data = await response.json();
    return data;
}

export const getCartCount = async url => getCount<GetCartSimpleResponse>(url);
export const getPurchaseListCount = async url => getCount<GetPurchaseListSimpleResponse>(url);
